import { AccountComponent } from './components/account.component';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AccountCardComponent } from './components/account-card/account-card.component';
import { PasswordSettingsComponent } from 'src/app/shared/components/password-settings/password-settings.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TechSupportPreviewComponent } from './components/tech-support-preview/tech-support-preview.component';
import { RouterModule } from '@angular/router';
import { FamilyManagementComponent } from './components/family-management/family-management.component';
import { FamilyMemberCardComponent } from './components/family-member-card/family-member-card.component';
import { EditAvatarModalComponent } from './components/edit-avatar-modal/edit-avatar-modal.component';
import { EditMemberDetailsModalComponent } from './components/edit-member-details-modal/edit-member-details-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteMemberModalComponent } from './components/delete-member-modal/delete-member-modal.component';
import { BillingInfoAndHistoryComponent } from './components/billing-info-and-history/billing-info-and-history.component';
import { BillingInfoComponent } from './components/billing-info/billing-info.component';
import { PaymentHistoryComponent } from './components/payment-history/payment-history.component';
import { ClaimsFlowComponent } from './components/claims-flow/claims-flow.component';
import { ClaimsQuestionComponent } from './components/claims-flow/claims-question/claims-question.component';
import { MatRadioModule } from '@angular/material/radio';
import { ClaimsMessageComponent } from './components/claims-flow/claims-message/claims-message.component';
import { FileAClaimModalComponent } from './components/claims-flow/file-a-claim-modal/file-a-claim-modal.component';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AccountProfileComponent } from './components/account-profile/account-profile.component';
import { ClaimsSelectDeviceComponent } from './components/claims-flow/claims-select-device/claims-select-device.component';
import { LazyElementsModule } from '@angular-extensions/elements';
import { PasswordFormModule } from 'src/app/shared/password/password-form/password-form.module';

import { CommunicationPreferencesComponent } from './components/communication-preferences/communication-preferences.component';

import { ContractDetailsPDFService } from 'src/app/core/services/contract-details-pdf.service';
import { SubscriptionComponent } from './components/subscription/subscription.component';



@NgModule({
  declarations: [
    AccountCardComponent,
    AccountComponent,
    AccountDetailsComponent,
    AccountProfileComponent,
    PasswordSettingsComponent,
    BillingInfoComponent,
    BillingInfoAndHistoryComponent,
    DeleteMemberModalComponent,
    EditAvatarModalComponent,
    EditMemberDetailsModalComponent,
    FamilyManagementComponent,
    CommunicationPreferencesComponent,
    FamilyMemberCardComponent,
    PaymentHistoryComponent,
    TechSupportPreviewComponent,
    ClaimsFlowComponent,
    ClaimsQuestionComponent,
    ClaimsMessageComponent,
    FileAClaimModalComponent,
    ClaimsSelectDeviceComponent,
    SubscriptionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatRadioModule,
    MatTabsModule,
    AppRoutingModule,
    LazyElementsModule,
    PasswordFormModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [ContractDetailsPDFService]
})
export class AccountModule { }
